/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Patch payload for ``PATCH /api/connected-accounts/linkedin/{id}``.
 */
export interface LinkedInAccountUpdate {
  default_signature_id?: string | null;
}
